export class LoginEntidade {
  public Cpf?: string;
  public Inscricao?: string;
  public Matricula?: string;
  public Senha?: string;
  public ReCAPTCHATokenV2?: string;
  public ReCAPTCHATokenV3?: string;
  public DataNascimento?: string;
  public Chave?: string;
  public SenhaAntiga?: string;
  public ConfirmarSenha?: string;
  public SenhaNova?: string;
  public TokenEnviado?: string;
  public TokenDigitado?: string;
  public Origem: number;
  public ExpiraEm?: number;
}
